import { CommandType } from './commandsList';

// Compute the edit distance between the two given strings
function getEditDistance(a: string, b: string) {
  if (a.length === 0) return b.length;
  if (b.length === 0) return a.length;

  const matrix = [];

  // increment along the first column of each row
  let i;
  for (i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }

  // increment each column in the first row
  let j;
  for (j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }

  // Fill in the rest of the matrix
  for (i = 1; i <= b.length; i++) {
    for (j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1, // substitution
          Math.min(
            matrix[i][j - 1] + 1, // insertion
            matrix[i - 1][j] + 1
          )
        ); // deletion
      }
    }
  }

  return matrix[b.length][a.length];
}

function indexOfSmallestNumberInArray(a: number[]): number {
  let lowest = 0;
  for (let i = 1; i < a.length; i++) {
    if (a[i] < a[lowest]) lowest = i;
  }
  return lowest;
}

export function calcMostSimilarSearchName(
  SearchName: string,
  commandList: CommandType[]
): { mostSimilarCommand: CommandType } {
  const listOfNamesToMatch = commandList.map((obj: CommandType) => obj.name);

  // if there is an exact match use eaxact match
  if (listOfNamesToMatch.indexOf(SearchName.split(' ')[0]) !== -1) {
    console.log('exact match', SearchName.split(' ')[0]);
    const searchForId1 = SearchName.split(' ')[1];
    console.log('searchForId1', searchForId1);

    const valueToReturn =
      commandList[listOfNamesToMatch.indexOf(SearchName.split(' ')[0])];

    const valueToReturnNew: CommandType = {
      name: valueToReturn.name,
      type: valueToReturn.type,
      path: valueToReturn.path.replace(':id', searchForId1),
    };
    console.log('valueToReturnNew', valueToReturnNew);

    return {
      mostSimilarCommand: valueToReturn,
    };
  } else {
    console.log('no exact match', SearchName.split(' ')[0]);
    // else use fancy function to measure similarity
    const listNrBySimilarity: number[] = listOfNamesToMatch.map(nameToMatch =>
      getEditDistance(nameToMatch, SearchName)
    );

    const positionInList = indexOfSmallestNumberInArray(listNrBySimilarity);
    const mostSimilarCommand = commandList[positionInList];
    console.log('SearchName', SearchName);
    console.log('mostSimilarCommand', mostSimilarCommand);
    //const sortedListBySimilarity =

    // const mostLikelyCorrectUrl = commandList[positionInList].name;
    // const shopName = commandList[positionInList].name;
    return { mostSimilarCommand: mostSimilarCommand };
  }
}
